/**
 * Creates a shallow clone of a step object.
 *
 * @param step - The step object to clone
 */
export function cloneStep<T>(step: T): T {
  return { ...step };
}
